import {RequestService} from "common/RequestService";

export function batchRequestToPublisher( queries ) {

    if( queries.length === 0 ){
        return Promise.resolve();
    }

    return new BatchRequester().start( queries );
}

function BatchRequester() {

    let queriesToSend = [];

    function requestNext( resolve, reject ) {

        const query = queriesToSend.shift();

        RequestService.sendAsyncLmsRequest( query, null ).then( ( response ) =>{

            if( response === "request_error" ) {
                reject("Error on publisher request!");
                return;
            }

            if( response === "false" ) {
                reject( "Error on LMS procedure!" )
                return;
            }

            if( queriesToSend.length > 0 ){
                requestNext( resolve, reject );
                return;
            }

            queriesToSend = [];
            resolve();
        });
    }

    return {

        start: ( queries ) => {

            if( queriesToSend.length > 0 ){
                return Promise.reject("BatchRequester is already in use!");
            }
            queriesToSend = queries;

            return new Promise( (resolve, reject ) => {
                requestNext( resolve, reject );
            });
        }
    }
}
